module.exports = __webpack_public_path__ + "static/img/ic_gy_fw_sh.110ffdd5.png";